import {Component} from '@angular/core';
import {BaseFieldType} from '../base-field-type';
import {NbButtonModule, NbFormFieldModule, NbIconModule, NbSelectModule, NbTooltipModule} from "@nebular/theme";
import {NgForOf, NgIf} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {FormlyModule} from "@ngx-formly/core";
import {NgSelectComponent} from "@ng-select/ng-select";

@Component({
  standalone: true,
  imports: [
    NbFormFieldModule,
    NgIf,
    NbButtonModule,
    NbIconModule,
    NbSelectModule,
    ReactiveFormsModule,
    FormlyModule,
    NgSelectComponent,
    NbTooltipModule,
    NgForOf
  ],
  templateUrl: './select-filter-property.component.html'
})
export class SelectFilterPropertyComponent extends BaseFieldType {
  get isMultiple() {
    return this.field.type == 'select-multi-filter-property' || this.props.multiple;
  }
}
